<template>
  <AnimatedContainer>
    <Container tag="section" space-y class="px-container sm:px-container-md">
      <!-- TITLE -->
      <h2
        v-if="data.heading"
        class="slide-up mb-6 whitespace-pre-wrap typo-heading-sm max-md:px-container"
        v-html="data.heading"
      />
      <AnimatedContainerScroll
        :breakpoints="[
          { breakpoint: '(min-width: 0px) and (max-width: 767px)', columns: 1 },
          {
            breakpoint: '(min-width: 768px) and (max-width: 1535px)',
            columns: 2,
          },
          {
            breakpoint: '(min-width: 1536px) and (max-width: 2559px)',
            columns: 3,
          },
          {
            breakpoint: '(min-width: 2560px) ',
            columns: 4,
          },
        ]"
      >
        <ul
          :id="`news-list-${data.id}`"
          class="grid grid-cols-1 gap-5 sm:gap-8 md:grid-cols-2 2xl:grid-cols-3 4xl:grid-cols-4"
        >
          <li
            v-for="(entry, index) in paginatedEntries"
            :key="entry.id"
            class="scroll-up"
            :data-index="index"
          >
            <CardNewsArticle :entry="entry" class="slide-left" />
          </li>
        </ul>
      </AnimatedContainerScroll>

      <Pagination
        :items-per-page="12"
        :scroll-to-id="`news-list-${data.id}`"
        :data="data.entries"
        class="slide-up"
        @update="paginatedEntries = $event"
      />

      <!-- NO RESULTS -->
      <div v-if="!data.entries.length" class="text-center">
        <IconMagnifyingGlass
          class="mx-auto my-10 mb-3 size-6 sm:mb-5 sm:size-10"
        />
        <p class="typo-body-sm">{{ $t('no_results') }}</p>
      </div>
    </Container>
  </AnimatedContainer>
</template>

<script setup lang="ts">
import type { MainComponentsOverviewNewsFragment } from '#gql'

defineProps<{
  data: Enforce<MainComponentsOverviewNewsFragment>
}>()

const paginatedEntries = ref([])
</script>
